/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
import { classNameOptions, profileTypeOptions } from "./constants";

const getBlanks = (text: any, index: number, parrentBlankIndex = 1) => {
    const parts: any[] = [];
    let blankIndex = parrentBlankIndex;
    if (!text.includes("()")) {
        parts.push({ type: "latex_span", val: text });
        return { parts, index };
    }
    const bool = true;
    while (bool) {
        const fibIndex = text.indexOf("()");
        if (fibIndex === -1) {
            parts.push({
                type: "latex_span",
                val: text.replace(/#neq/g, "\\neq"),
            });
            break;
        }
        parts.push({
            type: "latex_span",
            val: text.substring(0, fibIndex).replace(/#neq/g, "\\neq"),
        });
        index += 1;
        parts.push({
            type: "fib",
            val: index,
            blankIndex,
        });
        blankIndex += 1;
        text = text.substring(fibIndex + 2).replace(/#neq/g, "\\neq");
    }
    return { parts, index, blankIndex };
};

const getImages = (text: any, index: number) => {
    let parts: any[] = [];
    let bCount = index;
    if (!text.includes("<image")) {
        const prs = getBlanks(text, bCount);
        bCount = prs.index;
        parts = parts.concat(prs.parts);
        return { parts, index };
    }
    const bool = true;
    while (bool) {
        const imgIndex = text.indexOf("<image=");
        if (imgIndex === -1) {
            const prs = getBlanks(text, bCount);
            bCount = prs.index;
            parts = parts.concat(prs.parts);
            break;
        }
        const endIndex = text.indexOf('">');
        const prs = getBlanks(text.substring(0, imgIndex), bCount);
        bCount = prs.index;
        parts = parts.concat(prs.parts);
        parts.push({
            type: "img",
            val: text.substring(imgIndex + 8, endIndex),
        });
        text = text.substring(endIndex + 2);
    }
    return { parts, index };
};

export const getParts = (text: string, ParentblankIndex = 1): any[] => {
    const parts: any[] = [];
    if (!text) {
        return parts;
    }
    let txt = text.trim();
    txt = txt.replace("< image", "<image");
    txt = txt.replace("<image =", "<image=");
    txt = txt.replace("<image = ", "<image=");
    txt = txt.replace("<image= ", "<image=");
    txt = txt.replace('" >', '">');
    txt = txt.replace('="', '="');
    txt = txt.replace('">', '">');
    txt = txt.replace("'>", '">');
    txt = txt.replace(/\n/g, "\\n");
    let bCount = 0;

    // hack for not splitting at \neq
    txt = txt.replace("\\neq", "#neq");
    const splitted = txt.split("\\n");
    let blankIndex = ParentblankIndex;
    for (const splt of splitted) {
        const slptd = splt.split("\\n");
        for (let sp of slptd) {
            sp = sp.trim();
            if (sp === "") {
                parts.push({
                    type: "new_line",
                    val: "",
                });
            } else if (sp.includes("<image")) {
                const prs = getImages(sp, bCount);
                bCount = prs.index;
                parts.push({
                    type: "parts",
                    val: prs.parts,
                });
            } else if (sp.includes("\\dfrac") && sp.includes("()")) {
                // const sp = "a = \\dfrac{1+()}{()} + 1";
                const split1 = sp.split(/\\(dfrac)/);
                const mainParts = [];
                for (let i = 0; i < split1.length; i++) {
                    if (split1[i] !== "dfrac") {
                        mainParts.push({
                            type: "latex_div",
                            val: split1[i],
                        });
                    } else {
                        const st1 = split1[i] + split1[i + 1];
                        const arr = st1.match(/\{[^\}]*\}/g);
                        const blankBlock = [];

                        for (const ai of arr) {
                            const some = ai.slice(1, -1);
                            const len =
                                (some.split("()") &&
                                    some.split("()")?.length - 1) ||
                                0;
                            const res = getParts(some, blankIndex);
                            blankIndex += len;
                            blankBlock.push({ blankParts: res });
                        }
                        mainParts.push({
                            type: "dfrac",
                            blankBlock,
                        });
                        const split2 = st1.split(/\{[^\}]*\}/g);
                        if (split2[split2.length - 1] !== "") {
                            mainParts.push({
                                type: "latex_div",
                                val: split2[split2.length - 1],
                            });
                        }
                        i = i + 2;
                    }
                }
                parts.push({
                    type: "dfrac",
                    subParts: mainParts,
                });
            } else if (sp.includes("()")) {
                const prs = getBlanks(sp, bCount, blankIndex);
                bCount = prs.index;
                parts.push({
                    type: "parts",
                    val: prs.parts,
                });
                blankIndex = prs.blankIndex;
            } else {
                parts.push({
                    type: "latex_div",
                    val: sp.replace(/#neq/g, "\\neq"),
                });
            }
        }
    }
    return parts;
};

export const getClassNameValue = (class_name: string) => {
    if (!class_name) {
        return null;
    }
    const clName = parseInt(class_name.toLowerCase());
    if (Number.isNaN(clName)) {
        return null;
    }
    for (const cl of classNameOptions) {
        if (cl.value === clName) {
            return clName;
        }
    }
    return null;
};

export const getProfileTypeValue = (profileType: string) => {
    if (!profileType) {
        return null;
    }
    const pType = profileType.toLowerCase();
    for (const p of profileTypeOptions) {
        if (p.label.toLowerCase() === pType) {
            return p.value;
        }
    }
    return null;
};

export const getValidPhoneNumber = (mobile: string) => {
    if (!mobile) {
        return null;
    }
    const ph = parseInt(mobile.toLowerCase());
    if (Number.isNaN(ph)) {
        return null;
    }
    mobile = String(ph);
    if (mobile.length !== 10) {
        return null;
    }
    return mobile;
};

export const getDecodedUriString = (enc: string) => {
    if (!enc) {
        return "";
    }
    return decodeURIComponent(enc);
};
